import { FC, ReactElement, ComponentProps } from 'react';
import { useFragment, graphql } from 'react-relay';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import { Button } from 'dibs-elements/exports/Button';

import { SharedContactDealerWrapper } from '../../contactDealer/SharedContactDealerWrapper';

import { PdpSharedContactSellerButton_item$key } from './__generated__/PdpSharedContactSellerButton_item.graphql';
import { PdpSharedContactSellerButton_user$key } from './__generated__/PdpSharedContactSellerButton_user.graphql';

const userFragment = graphql`
    fragment PdpSharedContactSellerButton_user on User {
        ...SharedContactDealerWrapper_user
    }
`;

const itemFragment = graphql`
    fragment PdpSharedContactSellerButton_item on Item {
        ...SharedContactDealerWrapper_item
    }
`;

type ButtonProps = ComponentProps<typeof Button>;

export const PdpSharedContactSellerButton: FC<{
    children: ReactElement;
    dataTn?: string;
    item: PdpSharedContactSellerButton_item$key;
    user: PdpSharedContactSellerButton_user$key | null;
    type?: ButtonProps['type'];
    size?: ButtonProps['size'];
    launchOrigin?: string;
    fullWidth?: boolean;
    className?: string;
    selectedSkuId?: string;
    itemQuantity?: number;
}> = ({
    children,
    dataTn,
    type,
    size,
    launchOrigin,
    fullWidth,
    className,
    selectedSkuId,
    itemQuantity,
    ...props
}) => {
    const user = useFragment(userFragment, props.user);
    const item = useFragment(itemFragment, props.item);

    return (
        <CurrencyProvider
            render={({ currency }: $TSFixMe) => (
                <SharedContactDealerWrapper
                    launchOrigin={launchOrigin}
                    item={item}
                    user={user}
                    currency={currency}
                    selectedSkuId={selectedSkuId}
                    itemQuantity={itemQuantity}
                >
                    {(onClick: $TSFixMe) => (
                        <Button
                            fullWidth={fullWidth}
                            type={type}
                            size={size}
                            dataTn={dataTn}
                            onClick={onClick}
                            className={className}
                        >
                            {children}
                        </Button>
                    )}
                </SharedContactDealerWrapper>
            )}
        />
    );
};
